// src/components/features/Elevation/components/ElevationStep10Parapet.jsx
// Parapet design — swipe-style selection (folder "9.Parapet design" me
// "Radio" naam nahi tha, isliye swipe UI use kiya)

import ElevationSwipeStep from "./shared/ElevationSwipeStep";
import { PARAPET_IMAGES } from "../../../../assets/Elevation/elevationAssets";

export default function ElevationStep10Parapet(props) {
  return (
    <ElevationSwipeStep
      {...props}
      title="Parapet Design"
      subtitle="Swipe through parapet / railing styles and pick what you like"
      items={PARAPET_IMAGES}
      selectedFieldKey="elevationParapet"
      likedFieldKey="elevationLikedParapet"
    />
  );
}
